"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const structureValidations_1 = require("../../structureValidations");
const NodeBuilder_1 = __importDefault(require("./NodeBuilder"));
const SectionBuilder_1 = __importDefault(require("./SectionBuilder"));
class SectionGroupBuilder extends NodeBuilder_1.default {
    seedProviders;
    constructor(seedProviders) {
        super(seedProviders.forSectionGroup());
        this.seedProviders = seedProviders;
    }
    with(nodeBuilder) {
        if (nodeBuilder instanceof SectionBuilder_1.default) {
            return this.withSections(nodeBuilder);
        }
        return this.withSections(this.childBuilder().with(nodeBuilder));
    }
    withSections(sectionBuilders) {
        const builders = sectionBuilders ? lodash_1.default.castArray(sectionBuilders) : [];
        if (builders.length === 0) {
            builders.push(this.childBuilder());
        }
        if (builders.length === 0) {
            builders.push(new SectionBuilder_1.default(this.seedProviders));
        }
        const sections = builders.map((builder) => builder.build());
        if (!this.node.sections) {
            this.node.sections = [];
        }
        this.addSections(sections);
        return this.clone();
    }
    withSubsections(subsectionBuilders) {
        this.addSections(this.childBuilder().withSubsections(subsectionBuilders).build());
        return this.clone();
    }
    withFieldGroups(fieldGroupBuilders) {
        this.addSections(this.childBuilder().withFieldGroups(fieldGroupBuilders).build());
        return this.clone();
    }
    withFields(fieldBuilders) {
        this.addSections(this.childBuilder().withFields(fieldBuilders).build());
        return this.clone();
    }
    addSections(sections) {
        if (!this.node.sections)
            this.node.sections = [];
        const sectionList = lodash_1.default.castArray(sections);
        this.node.sections.push(...sectionList);
    }
    childBuilder() {
        return new SectionBuilder_1.default(this.seedProviders);
    }
    withId(id) {
        this.node.id = id;
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    visibleIf(condition) {
        this.node.visibleIf = condition;
        return this.clone();
    }
    makeRepeatable({ nodeId }) {
        this.node.options = {
            repeatable: true,
            minRepetitions: 1,
            maxRepetitions: 3,
        };
        const repeatableSectionGroup = this.node;
        repeatableSectionGroup.nodeId = nodeId;
        return this.clone();
    }
    validate(sectionGroup) {
        return (0, structureValidations_1.validateSectionGroup)(sectionGroup);
    }
}
exports.default = SectionGroupBuilder;
